import type { Purchase_Schema } from "@/services/marketplace/order/purchases/purchasesSchema";
import { type InjectionKey, type Ref } from "vue";
import type { z } from "zod";

export type Purchase = z.infer<typeof Purchase_Schema>;

export type purchaseInjectionKeyType = Ref<Purchase | undefined>;
export const purchaseInjectionKey = Symbol() as InjectionKey<purchaseInjectionKeyType>;
